<template>
  <div>
    <label for="bookingRoomSelected" v-if="isShownLabel"
      >Room<span v-if="required" class="required">*</span></label
    >
    <multiselect
      id="bookingRoomSelected"
      v-model="room"
      :options="rooms"
      label="text"
      track-by="id"
      :disabled="setDisable"
      style="margin: 0.6rem 0 0"
    >
    </multiselect>
  </div>
</template>

<script>
import BookingService from "services/api/booking.service";
import { assembleDropdown } from "@/utils/dropdown";
import { emitLoadingStart, emitLoadingDone } from "@/utils/loading";

export default {
  name: "BookingRoomDropdown",
  props: {
    value: { type: Object, default: null },
    setDisable: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    storeCode: { type: String, default: null },
    bookingId: { type: Number, default: null },
    serviceId: { type: Number, default: null },
    date: { type: String, default: null },
    time: { type: String, default: null },
    resourceChecking: { type: Boolean, default: false },
    isShownLabel: { type: Boolean, default: true },
  },
  data() {
    return {
      room: this.value,
      rooms: [],
    };
  },
  created() {
    if (this.resourceChecking) {
      if (this.serviceId && this.date && this.time) {
        this.getRooms(
          this.storeCode,
          this.bookingId,
          this.serviceId,
          this.date,
          this.time
        );
      }
    } else if (this.storeCode) {
      this.getRooms(this.storeCode, null, null, null, null);
    }
  },
  watch: {
    room(newValue) {
      this.$emit("setRoom", newValue);
    },
    value(newValue) {
      this.room = newValue;
    },
    rooms(newValue) {
      this.$emit("setRooms", newValue);
    },
    storeCode(newStoreCode) {
      if (newStoreCode && !this.resourceChecking) {
        this.getRooms(newStoreCode, null, null, null, null);
      } else {
        this.rooms = [];
      }
    },
    time(newTime) {
      if (newTime) {
        this.getRooms(
          this.storeCode,
          this.bookingId,
          this.serviceId,
          this.date,
          newTime
        );
      } else {
        this.rooms = [];
      }
    },
  },
  methods: {
    async getRooms(storeCode, bookingId, serviceId, date, time) {
      try {
        emitLoadingStart(this);
        await BookingService.getRooms({
          storeCode: storeCode,
          bookingId: bookingId,
          serviceId: serviceId,
          date: date,
          time: time,
        })
          .then(async (res) => {
            this.rooms = assembleDropdown(await res.data.items);
          })
          .catch((error) => {
            console.log("Error: ", error);
          });
      } catch (error) {
        console.log("Error: ", error);
      }
      emitLoadingDone(this);
    },
  },
};
</script>
